import { QuoteView } from '../views/quote-view';

export const QuoteViewTemplate: QuoteView = {
	origin: 'Origin',
	destination: 'Destination',
	trailerType: 'Trailer Type',
	description: 'Commodity',
	pickupDate: 'Pickup Date',
	deliveryDate: 'Delivery Date',
	totalWeight: 'Total Weight',
	reference: 'Reference #',
	revenueCode: 'Revenue Code',
	buyNowPrice: 'Buy Now Price',
	orderType: 'Order Type',
};
